<script lang="ts">
	import type { CompleteVariant } from '$lib/types';
	import { transformProductCollectionsToBranch } from '$lib/utils/product';
	import ProductCardGenericSlider from '../Slider/ProductCardGenericSlider.svelte';
	import { classes } from '@thearc-hq/ui-kit/utils';
	import ProductCardVertical from './ProductCardVertical.svelte';
	import { getTranslate } from '@tolgee/svelte';
	import { createCrossSellStores } from '$lib/store/crossSell.store';

	const { t } = getTranslate();

	export let title: string = $t('product.recommendedProducts.title');
	export let productCrossSellReferences: CompleteVariant['crossSellReferences'] | undefined;
	export let variantCrossSellReferences: CompleteVariant['crossSellReferences'] | undefined;

	let scrollerRef: HTMLElement;
	$: stores = createCrossSellStores(productCrossSellReferences, variantCrossSellReferences);
</script>

<ProductCardGenericSlider
	bind:scrollerRef
	class={$stores.length > 0 ? '' : 'min-h-0'}
	title={$stores.length > 0
		? $t('product.recommendedProducts.title')
		: $t('product.recommendedProducts.empty')}
>
	{#each $stores as { data }, i}
		{#if data && data?.product && data?.product?.product}
			<ProductCardVertical
				{...data.product.product}
				branch={transformProductCollectionsToBranch(data?.product?.product?.collections)}
				sku={data.sku}
				class={classes('flex-none w-92', 'snap-start')}
				sourceExtra="Slider Cross-Sell"
			/>
		{/if}
	{/each}
</ProductCardGenericSlider>
